import { Box, IconButton, Stack, SvgIcon } from '@mui/material';
import { ReactElement } from 'react';
import {
  AppFormikButtonTiles,
  AppPrimaryButton,
} from 'shared/components/AppComponents';
import PageHeader from 'shared/components/PageHeader';
import { ReactComponent as Plus } from 'assets/images/ic_plus.svg';
import { Formik } from 'formik';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IAppState } from 'state/RootReducer';
import TeamMembersTab from './TeamMembersTab';
import PendingInvitesTab from './PendingInvitesTab';
import NewInviteTab from './NewInviteTab';

const ManageTeam = (): ReactElement => {
  const navigate = useNavigate();
  const { baseAppState } = useSelector((state: IAppState) => state);

  return (
    <Box>
      <Formik
        initialValues={{ status: [true, false, false] }}
        onSubmit={() => {
          // Form submission handled by button click
        }}
      >
        {({ values, setFieldValue }) => (
          <>
            <PageHeader
              title={baseAppState.activeOrg.name}
              description="Manage, your team and invitation"
              leftBackButton={
                <IconButton
                  onClick={() => {
                    navigate('/settings?tabIndex=2');
                  }}
                >
                  <ArrowBackIosIcon />
                </IconButton>
              }
              actions={
                <AppPrimaryButton
                  className="btn-small"
                  onClick={() => setFieldValue('status', [false, false, true])}
                  startIcon={
                    <SvgIcon
                      component={Plus}
                      inheritViewBox
                      className="view-icon"
                      fontSize="inherit"
                    />
                  }
                  title="Invite Teammate"
                />
              }
            />
            <Stack className="mx-8" direction="column" spacing={2}>
              <AppFormikButtonTiles
                variant="outlined"
                name="status"
                size="small"
                label=""
                disabled={false}
                multichoice={false}
                className="app-group-button"
                buttons={[
                  { value: 'Team Members' },
                  { value: 'Pending Invites' },
                  { value: 'New Invite' },
                ]}
                outerLabel
              />

              {values.status[0] && <TeamMembersTab />}

              {values.status[1] && <PendingInvitesTab />}

              {values.status[2] && (
                <NewInviteTab
                  onNewMemberInvite={() => {
                    setFieldValue('status', [false, true, false]);
                  }}
                />
              )}
            </Stack>
          </>
        )}
      </Formik>
    </Box>
  );
};

export default ManageTeam;
